var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$page.props.auth.user
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "ml-3 relative" },
            [
              _c("jet-dropdown", {
                attrs: { align: "right", width: "48" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function () {
                        return [
                          _c(
                            "v-card",
                            { staticStyle: { "border-radius": "50px" } },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "flex align-center text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out",
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "h-8 w-8 rounded-full object-cover",
                                    attrs: {
                                      src: _vm.$page.props.auth.user
                                        .profile_photo_url,
                                      alt: _vm.$page.props.auth.user.name,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mx-1 soli-grey flex align-center",
                                      staticStyle: { "line-height": "12px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$page.props.auth.user.first_name
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "soli-grey",
                                      attrs: { dense: "" },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _vm.$page.props.auth.user
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                  attrs: {
                                    href: `/profile/${_vm.$page.props.auth.user.id}/account`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    View Profile\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                              attrs: { href: "/help-articles" },
                            },
                            [_vm._v("Help")]
                          ),
                          _vm._v(" "),
                          _vm.$page.props.auth.user
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "soli-round soli-grey block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                  on: {
                                    click: function ($event) {
                                      _vm.composeEmail = true
                                    },
                                  },
                                },
                                [_vm._v("Share Feedback")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "error--text soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                              attrs: { href: "/logout" },
                            },
                            [
                              _vm._v(
                                "\n                    Logout\n                "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1361776153
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.composeEmail
            ? _c("ComposeEmail", {
                attrs: {
                  emails: ["feedback@musicologie.com"],
                  errors: _vm.errors,
                  user: _vm.$page.props.auth.user,
                },
                on: {
                  success: function ($event) {
                    return _vm.emailSuccess()
                  },
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.composeEmail = false))
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }